import React from 'react';

const FooterQuote = ({ quote, attribution, variant }) => (
  <section className={`main-page-footer-quote main-page-footer-quote--${variant}`} aria-label="Inspirational quote">
    <div className="main-page-footer-quote-overlay">
      <blockquote>
        <p>“{quote}”</p>
        <cite>{attribution}</cite>
      </blockquote>
    </div>
  </section>
);

export default FooterQuote;
